import { UserRole } from "Infrastructure/Api/Api";
import { useAuth } from "Infrastructure/Contexts/AuthContext";

export const useRole = () => {
  const { user } = useAuth();
  const role = user?.role ?? null;

  return {
    role,
    isGameMaster: role === UserRole.GameMaster,
    isUser: role === UserRole.User,
    isProjectManager: role === UserRole.ProjectManager,
    hasRole: (requiredRole: UserRole) => role === requiredRole,
    canAccess: (allowedRoles: UserRole[]) =>
      role ? allowedRoles.includes(role) : false,
  };
};
